// extracted by mini-css-extract-plugin
export default {"link":"NavMenu_link__7YF6+","active":"NavMenu_active__2yzsv"};